var map = {
	"./chest.svg": "b961",
	"./hip.svg": "3de7",
	"./leftbicep.svg": "2605",
	"./leftcalf.svg": "1ccd",
	"./leftthigh.svg": "0be1",
	"./lowerabs.svg": "9987",
	"./neck.svg": "0eea",
	"./rightbicep.svg": "382f",
	"./rightcalf.svg": "d551",
	"./rightthigh.svg": "9a4c",
	"./shoulder.svg": "7fec",
	"./upperabs.svg": "23e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "159d";